import axios from 'axios';

export default {
	getMetrics(filters = {}) {
		const queryParams = Object.fromEntries(Object.entries(filters).filter(([_, value]) => value !== undefined && value !== null && value !== ''));

		return axios.get('/api/performance-metrics', {
			params: queryParams,
		});
	},
};
